var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { apiCreatePopupRead } from '@/actions/PopupActions';
import { canUseHotlineProUser } from '@/feature/hotline/professional/util/canUseHotlineUser';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { POPUP_TYPE_PROFESSIONAL_HOTLINE_TERM_AGREEMENT } from '@/utils/constants/popup/eventType';
/**
 * 匿名ホットライン利用規約同意（コンサル）のカスタムフック
 */
export const useHotlineProTermsAgree = () => {
    var _a;
    const dispatch = useDispatch();
    // ユーザー情報取得
    const { auth, profile } = useTypeSelector((state) => ({
        auth: state.auth,
        profile: state.profile,
    }));
    /** 匿名ホットライン利用可能ユーザーか */
    const canUseHotline = canUseHotlineProUser(profile, auth);
    /** 未同意か */
    const isNotAgreement = !!((_a = profile === null || profile === void 0 ? void 0 : profile.viewPopups) === null || _a === void 0 ? void 0 : _a.some((type) => type === POPUP_TYPE_PROFESSIONAL_HOTLINE_TERM_AGREEMENT));
    /**
     * 送信処理
     */
    const onSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapDispatch(dispatch, apiCreatePopupRead(POPUP_TYPE_PROFESSIONAL_HOTLINE_TERM_AGREEMENT, {}));
    }), [dispatch]);
    return {
        needsAgreement: isNotAgreement && canUseHotline,
        onSubmit,
    };
};
